import { render } from "./index.vue?vue&type=template&id=851487ca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=851487ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-851487ca"

export default script